import CustomerSuffix from "components/Parts/Selects/CustomerSuffix";

const PartsSelect = {
	CustomerSuffix: CustomerSuffix
};

export default PartsSelect;
